
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $9G9Pp = parcelRequire("9G9Pp");
// Loading
const $2b1eb37d04ecb9e9$var$createLoading = ()=>{
    const loadingElement = document.createElement('div');
    loadingElement.id = 'loading';
    const loaderElement = document.createElement('div');
    loaderElement.classList.add('loader');
    loadingElement.appendChild(loaderElement);
    document.body.appendChild(loadingElement);
};
const $2b1eb37d04ecb9e9$var$removeLoading = ()=>{
    const loadingElement = document.getElementById('loading');
    if (loadingElement) loadingElement.style.opacity = '0';
    setTimeout(()=>{
        if (loadingElement) loadingElement.style.display = 'none';
    }, 250);
};
$2b1eb37d04ecb9e9$var$createLoading();
window.addEventListener('DOMContentLoaded', ()=>{
    $2b1eb37d04ecb9e9$var$removeLoading();
});
// nav 阴影
const $2b1eb37d04ecb9e9$var$navDom = document.querySelector('#nav');
window.addEventListener('scroll', ()=>{
    requestIdleCallback(()=>{
        if (document.documentElement.scrollTop === 0) $2b1eb37d04ecb9e9$var$navDom.style.boxShadow = '0 0 0 ';
        else $2b1eb37d04ecb9e9$var$navDom.style.boxShadow = 'rgba(0, 0, 0, 0.04) 0 3px 5px';
    });
});
// nav 菜单
const $2b1eb37d04ecb9e9$var$navMenuDom = document.querySelector('#nav > div.container.small > div.menu');
const $2b1eb37d04ecb9e9$var$navMenuItemsDom = document.querySelector('#nav > div.container.small > div.menu > ul');
const $2b1eb37d04ecb9e9$var$navMenuInputDom = document.querySelector('#burger');
let $2b1eb37d04ecb9e9$var$isMenuOpen = false;
const $2b1eb37d04ecb9e9$var$showMenu = ()=>{
    (0, $9G9Pp.default).to($2b1eb37d04ecb9e9$var$navMenuItemsDom, {
        height: 'auto',
        duration: 0.2,
        ease: 'power2.in'
    });
    $2b1eb37d04ecb9e9$var$isMenuOpen = true;
    $2b1eb37d04ecb9e9$var$navMenuInputDom.checked = false;
};
const $2b1eb37d04ecb9e9$var$hideMenu = ()=>{
    (0, $9G9Pp.default).to($2b1eb37d04ecb9e9$var$navMenuItemsDom, {
        height: 0,
        duration: 0.2,
        ease: 'power2.in'
    });
    $2b1eb37d04ecb9e9$var$isMenuOpen = false;
    $2b1eb37d04ecb9e9$var$navMenuInputDom.checked = true;
};
const $2b1eb37d04ecb9e9$var$initMenuStatus = ()=>{
    (0, $9G9Pp.default).set($2b1eb37d04ecb9e9$var$navMenuItemsDom, {
        height: 0
    });
    $2b1eb37d04ecb9e9$var$navMenuInputDom.checked = false;
};
window.addEventListener('load', ()=>{
    $2b1eb37d04ecb9e9$var$initMenuStatus();
});
$2b1eb37d04ecb9e9$var$navMenuDom.addEventListener('click', (e)=>{
    e.stopPropagation();
    if (!$2b1eb37d04ecb9e9$var$isMenuOpen) $2b1eb37d04ecb9e9$var$showMenu();
    else $2b1eb37d04ecb9e9$var$hideMenu();
});
window.addEventListener('click', ()=>{
    if ($2b1eb37d04ecb9e9$var$isMenuOpen) $2b1eb37d04ecb9e9$var$hideMenu();
});
const $2b1eb37d04ecb9e9$var$navMenuLinkDomList = document.querySelectorAll('#nav > div.container.small > div.menu > ul > li > a');
$2b1eb37d04ecb9e9$var$navMenuLinkDomList.forEach((item)=>{
    item.addEventListener('click', (e)=>{
        e.stopPropagation();
    });
});
$2b1eb37d04ecb9e9$var$navMenuInputDom.addEventListener('click', (e)=>{
    e.stopPropagation();
    e.stopImmediatePropagation();
});
// footer
const $2b1eb37d04ecb9e9$var$wechatDom = document.querySelector('#footer > div > ul:nth-child(2) > li.wechat > span');
const $2b1eb37d04ecb9e9$var$wechatImgDom = document.querySelector('#footer > div > ul:nth-child(2) > li.wechat > img');
$2b1eb37d04ecb9e9$var$wechatDom.addEventListener('mouseenter', ()=>{
    (0, $9G9Pp.default).to($2b1eb37d04ecb9e9$var$wechatImgDom, {
        opacity: 1,
        duration: 0.3,
        display: 'block'
    });
});
$2b1eb37d04ecb9e9$var$wechatDom.addEventListener('mouseleave', ()=>{
    (0, $9G9Pp.default).to($2b1eb37d04ecb9e9$var$wechatImgDom, {
        opacity: 0,
        duration: 0.3,
        display: 'none'
    });
}) // 图片懒加载
 // const lazyLoadImages = () => {
 //   const images = document.querySelectorAll(`img`)
 //   console.log(images)
 //   const loadImage = (img) => {
 //     const src = img.getAttribute('data-src')
 //     if (src) {
 //       img.style.display = 'block !important'
 //     }
 //   }
 //
 //   const observer = new IntersectionObserver((entries) => {
 //     entries.forEach((entry) => {
 //       if (entry.isIntersecting) {
 //         loadImage(entry.target)
 //         observer.unobserve(entry.target)
 //       }
 //     })
 //   })
 //
 //   images.forEach((img) => {
 //     observer.observe(img)
 //   })
 // }
 //
 // window.addEventListener('DOMContentLoaded', () => {
 //   lazyLoadImages()
 // })
;


//# sourceMappingURL=index.2e449345.js.map
